module.exports = __webpack_public_path__ + "img/icon_add_friend.e57afda5.svg";